import { useContext } from "react";

import { useQuery } from "@tanstack/react-query";
import { getSubscription } from "services/Subscription.services";

import { AuthTokenContext } from "components/AuthProvider/AuthProviderContext";

export default function useSubscription() {
  const token = useContext(AuthTokenContext);

  const {
    data: subscription,
    isLoading: isSubscriptionLoading,
    refetch,
  } = useQuery({
    queryKey: ["subscription"],
    queryFn: () => getSubscription(),
    enabled: !!token,
  });

  const isActive = subscription?.package?.isActive === true;
  const isTrial = subscription?.package?.isTrial === true;

  return { subscription, isSubscriptionLoading, refetch, isActive, isTrial };
}
